module.exports = __webpack_public_path__ + "img/28.5fe85395.jpg";